var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content home-page"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"information2"},[(_vm.list!='')?_c('div',{staticClass:"faq-content"},[_c('div',{},[_c('p',{staticClass:"fs50 ac"},[_c('span',[_vm._v(_vm._s(_vm.$t('FAQ')))])]),_vm._v(" "),_c('p',{staticClass:"mt30",domProps:{"innerHTML":_vm._s(_vm.list)}})])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d2d29b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/faq.vue
// module id = null
// module chunks = 